module.exports = __webpack_public_path__ + "static/profile-2c06822a6b153ab4988a016c80abca75.png";